import { useEffect, useRef } from "react";
import * as signalR from "@microsoft/signalr";
import { useDispatch } from "react-redux";

const useSignalR = (coachId, hubUrl, eventName, getNotificationDetails, getAnnouncementList) => {
  const connectionRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!coachId || !getNotificationDetails || !getAnnouncementList) return;

    // Initialize SignalR connection
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl)
      // .withAutomaticReconnect()
      .withKeepAliveInterval(30000) // 30 seconds
      .withServerTimeout(60000) // 60 seconds
      .build();

    connectionRef.current = connection;

    // Listen for incoming messages
    connection.on(eventName, (user, message) => {
      // console.log("SignalR message received:", user, message);
      // Check if the message is not null or undefined
      message && dispatch(getNotificationDetails({ coachId }));
      message && dispatch(getAnnouncementList({ coachId }));
    });

    // Start SignalR connection
    connection
      .start()
      .then(() => {
        //console.log("SignalR connection started.")
      })
      .catch((err) => {
        console.error("SignalR connection error:", err);
      });

    // Cleanup function to stop the connection
    return () => {
      if (connectionRef.current) {
        connectionRef.current.stop().then(() => {
          // console.log("SignalR connection stopped.");
        });
      }
    };
  }, [coachId, hubUrl, eventName, getNotificationDetails, dispatch, getAnnouncementList]);
};

export default useSignalR;
